export enum MatColor {
  PRIMARY = 'PRIMARY',
  ACCENT = 'ACCENT',
  WARN = 'WARN'
}

export enum BoolEditor {
  CHECKBOX = 'CHECKBOX',
  SLIDETOGGLE = 'SLIDETOGGLE'
}
